export function computeYAxisTickCount(values, key = 'y') {
    return Math.min(Math.max(1, ...values.map((p) => p[key])), 4);
}
